// extracted by mini-css-extract-plugin
module.exports = {"page":"_2zXMyKO45mL-F28XNYWp0t","loginWindow":"_2UZ3DN_jQdq-4D6bM2oA_X","welcomeMessage":"_2CZNtqfrDupqf5_69T8iOD"};